import { MealTime } from "@/clients/models/MealTime";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { PageTitleComponent } from "@/components/page-title";
import MealProgressBar from "@/components/progress/meal-progress-bar";
import { mealTabs } from "@/constants/meal-tab";
import { useGetCandidates } from "@/hooks/requests/go-to/use-get-candidates";
import { useSearchParams } from "@/hooks/router/use-search-params";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { IonSkeletonText, useIonRouter } from "@ionic/react";
import GoToMealSwiper from "../../components/meal-swiper/go-to-meal-swiper";

export default function OnboardingGoToAddPlan() {
  const { info } = useStepRouteInfo();
  const navigation = useIonRouter();
  const searchParams = useSearchParams();
  const mealTime =
    (searchParams.get("mealTime") as MealTime) ?? MealTime.BREAKFAST;
  const { candidates, isLoading } = useGetCandidates(mealTime);
  const currentCandidate = candidates?.[mealTime] ?? [];

  return (
    <ProfilePageContainer className="h-full flex flex-col items-center justify-center">
      <PageTitleComponent
        title="My Top Picks"
        description="Based on your top picks, we think you'll love these. You can choose up to 2 favorites."
      />

      <MealProgressBar activeMealTime={mealTime} />

      {isLoading ? (
        <div className="flex-1 w-full flex flex-col gap-4">
          <IonSkeletonText animated className="w-full h-[20rem]" />
          <IonSkeletonText animated className="w-full h-10" />
        </div>
      ) : (
        <GoToMealSwiper
          mealTime={mealTime}
          meals={currentCandidate}
          onCompleted={() => {
            const currentIndex = mealTabs.indexOf(mealTime);
            const nextMealTime = mealTabs[currentIndex + 1];

            if (nextMealTime) {
              const newSearchParams = new URLSearchParams(searchParams);
              newSearchParams.set("mealTime", nextMealTime);
              navigation.push(
                `${location.pathname}?${newSearchParams.toString()}`,
                "none",
              );
            } else {
              navigation.push(info?.nextPath ?? "", "none");
            }
          }}
        />
      )}
    </ProfilePageContainer>
  );
}
